export default "__VITE_ASSET__4lIERDJ7__"